import "core-js/modules/es.array.join";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  data: function data() {
    var days = [];

    for (var i = 10; i >= 1; i--) {
      days.push(this.getDay(new Date(), i));
    }

    var initData = [];

    for (var _i in days) {
      initData.push({
        day: days[_i],
        num: 0
      });
    }

    return {
      legend: {
        top: 20,
        textStyle: {
          color: 'white',
          //这里是改变字体颜色
          fontSize: 15 //字体大小

        }
      },
      colors: ['#F56C6C'],
      data: {
        'columns': ['day', 'num'],
        'rows': initData
      },
      yAxis: [{
        axisLabel: {
          show: false,
          textStyle: {
            color: 'white',
            //这里是改变字体颜色
            fontSize: 15 //字体大小

          }
        },
        splitLine: {
          show: false
        }
      }],
      xAxis: [{
        name: '日期',
        type: 'category',
        axisLabel: {
          show: true,
          rotate: 30,
          textStyle: {
            color: 'white',
            fontSize: 13
          }
        },
        splitLine: {
          show: false
        }
      }],
      'grid': {
        'backgroundColor': 'transparent',
        'borderColor': 'transparent',
        'borderWidth': 0,
        'bottom': 60,
        'height': 'auto',
        'left': '10%',
        'right': '10%',
        'shadowBlur': 0,
        'shadowColor': 'rgba(0, 0, 0, 0)',
        'shadowOffsetX': 0,
        'shadowOffsetY': 0,
        'show': false,
        'tooltip': {
          'show': true
        },
        'top': 60,
        'width': 'auto'
      },
      'settings': {
        'area': true,
        'digit': 2,
        'itemStyle': {
          'borderColor': '#000',
          'borderType': 'solid',
          'borderWidth': 0,
          'shadowBlur': 0,
          'shadowColor': 'rgba(0, 0, 0, 0)',
          'shadowOffsetX': 0,
          'shadowOffsetY': 0
        },
        'labelMap': {
          'num': '新增会员'
        },
        'showLine': [],
        'type': 'line',
        'xAxisType': 'category',
        'yAxisType': 'normal'
      }
    };
  },
  methods: {
    update: function update(value) {
      this.data = {
        'columns': ['day', 'num'],
        'rows': value
      };
    },
    getDay: function getDay(begin, num) {
      var new_ = new Date((begin.getTime() / 1000 - num * 86400) * 1000);
      var time_ = new_.toLocaleDateString().replace(/\//g, "-");
      var arr = time_.split("-");
      arr[1] = '0' + arr[1] < 10 ? '0' + arr[1] : arr[1];
      arr[2] = '0' + arr[2] < 10 ? '0' + arr[2] : arr[2];
      return arr.join('-');
    }
  }
};